
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { namespace } from 'vuex-class';
import { SendAccountRecoveryEmailDto } from '@/store/modules/auth';
import ChangePasswordForm from '../components/ChangePasswordForm.vue';
import TextField from '../components/TextField.vue';
import CardActions from '../components/CardActions.vue';

const Auth = namespace('Auth');
const Loader = namespace('Loader');
const Config = namespace('Config');

// eslint-disable-next-line no-shadow
enum Step {
  ForgotPassword,
  ForgotPasswordSuccess,
  ForgotPasswordContactUs,
  ForgotPasswordContactUsSuccess,
}

@Component({
  components: {
    ChangePasswordForm,
    ValidationObserver,
    ValidationProvider,
    TextField,
    CardActions,
  },
})
export default class ForgotPassword extends Vue {
  private readonly Step = Step;

  private stepVal: Step = Step.ForgotPassword;

  private username = '';

  private censoredEmail = '';

  private contact = {
    name: '',
    email: '',
    phone: '',
    organisation: '',
    additional: '',
  };

  @Auth.Action
  private readonly requestAccountRecovery!: (dto: SendAccountRecoveryEmailDto) => Promise<any>;

  @Auth.Action
  private readonly requestPasswordReset!: (dto: any) => Promise<any>;

  @Config.Getter
  private readonly redirectUri!: string | null;

  @Config.Getter
  private readonly clientId!: string | null;

  @Loader.Action('run')
  private readonly runWithLoader!: <T>(fn: Promise<T>) => Promise<T>;

  mounted(): void {
    this.$router.onReady(() => {
      const { username } = this.$route.query;
      if (username) {
        this.username = username.toString();
      }
    });

    this.$store.dispatch('clearError');
  }

  get step(): Step {
    return this.stepVal;
  }

  set step(value: Step) {
    this.$store.dispatch('clearError');
    this.stepVal = value;
  }

  redirect(): void {
    if (this.redirectUri) {
      window.location.href = this.redirectUri;
    }
  }

  private async getRecaptchaToken(action: string): Promise<string> {
    await this.$recaptchaLoaded();
    return this.$recaptcha(action);
  }

  async handleAccountRecoveryRequest(): Promise<void> {
    const result = await this.runWithLoader(
      this.requestAccountRecovery({
        ...this.contact,
        redirectUri: this.redirectUri ?? undefined,
        username: this.username,
        recaptchaResponse: await this.getRecaptchaToken('account_recovery'),
      }),
    );

    if (result) {
      this.step = Step.ForgotPasswordContactUsSuccess;
    }
  }

  async handleForgotPasswordRequest(): Promise<void> {
    const result = await this.runWithLoader(
      this.requestPasswordReset({
        usernameOrEmail: this.username,
        clientId: this.clientId,
        recaptchaResponse: await this.getRecaptchaToken('forgot_password'),
      }),
    );

    if (result) {
      this.step = result.email ? Step.ForgotPasswordSuccess : Step.ForgotPasswordContactUs;
      this.censoredEmail = result.email;
    }
  }
}
